module.exports = __webpack_public_path__ + "img/barragan_des.ed437b4e.jpg";